/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { isTrue } from "utils/empty-exists";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons";

const TextStyleLink = (props) => {

    const link = props?.link;
    const style = props?.style;
    const isExternal = isTrue(link?.is_external);
    const internalNewTab = link?.new_tab ?? false;
    const openInNewTab = isExternal || internalNewTab;

    return (
        <>
            <a
                href={link?.url}
                className={`displayLink ${style} `}
                target={openInNewTab ? "_blank" : "_self"}
                rel='noreferrer'
            >
                {link.text}
                {/*{isExternal &&*/}
                {/*    <SVGIcons.fields.LinkField />*/}
                {/*}*/}
            </a>
            {isExternal &&
                <span className='simplicity-link-icon'>&nbsp;<FontAwesomeIcon icon={faArrowUpRightFromSquare} size='1x' /></span>
            }
        </>
    );
};

export { TextStyleLink };
